import { render, staticRenderFns } from "./InventoryTypeList.vue?vue&type=template&id=7aa88d47"
import script from "./InventoryTypeList.vue?vue&type=script&lang=js"
export * from "./InventoryTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports